// Regras de QUANTIDADE por produto (nível de front, primeira versão).
//
// Alguns produtos só formam uma compra válida quando aparecem no carrinho numa
// certa quantidade. Ex.: "Casal" só é válido em múltiplos de 2 (2, 4, 6...);
// "Família" exige no mínimo 3 inscrições.
//
// A regra é resolvida por um matcher (`match`) sobre o produto. AJUSTE os
// matchers abaixo para bater com os nomes/subtipos reais cadastrados no banco.
// Se preferir, dá pra casar por `_id`, `valor` ou `tipo` em vez de nome.
//
// Campos de cada regra (todos além de `match` são opcionais):
//   - match(produto) => boolean : identifica a qual produto a regra se aplica
//   - label                     : nome amigável usado nas mensagens
//   - minimo                    : quantidade mínima no carrinho
//   - multiplo                  : a contagem precisa ser múltiplo desse número
//   - maximo                    : teto de quantidade (quando existir)

const contem = (produto, termo) => {
  const alvo = `${produto?.nome || ""} ${produto?.subtipo || ""}`.toLowerCase();
  return alvo.includes(termo);
};

export const REGRAS_QUANTIDADE = [
  {
    label: "Casal",
    match: (produto) => contem(produto, "casal"),
    minimo: 2,
    multiplo: 2, // 2, 4, 6...
  },
  {
    label: "Família",
    match: (produto) =>
      contem(produto, "família") || contem(produto, "familia"),
    minimo: 3, // 3 ou mais, sem teto
  },
  {
    label: "Combo",
    match: (produto) => contem(produto, "combo"),
    minimo: 2, // "mais do que 3" = a partir de 4. Troque para 3 se for "3 ou mais".
  },
];

// Retorna a regra aplicável a um produto, ou null se ele for de quantidade livre.
export const getRegraQuantidade = (produto) =>
  REGRAS_QUANTIDADE.find((regra) => regra.match(produto)) || null;

// Valida a quantidade de UM produto contra sua regra.
// Retorna { valido: boolean, mensagem?: string }.
export const validarQuantidadeProduto = (produto, quantidade) => {
  const regra = getRegraQuantidade(produto);
  if (!regra) return { valido: true };

  const nome = regra.label || produto?.nome || "Este produto";

  if (regra.minimo && quantidade < regra.minimo) {
    return {
      valido: false,
      mensagem: `${nome}: mínimo de ${regra.minimo} inscrições (você tem ${quantidade}).`,
    };
  }

  if (regra.maximo != null && quantidade > regra.maximo) {
    return {
      valido: false,
      mensagem: `${nome}: máximo de ${regra.maximo} inscrições (você tem ${quantidade}).`,
    };
  }

  if (regra.multiplo && regra.multiplo > 1 && quantidade % regra.multiplo !== 0) {
    return {
      valido: false,
      mensagem: `${nome}: as inscrições devem ser em múltiplos de ${regra.multiplo} (você tem ${quantidade}).`,
    };
  }

  return { valido: true };
};

// Valida o carrinho inteiro. Agrupa os itens por produto (cada item do carrinho
// equivale a 1 inscrição) e checa a regra de cada produto.
// Retorna a lista de mensagens de erro — vazia significa carrinho válido.
export const validarCarrinho = (carrinho = []) => {
  const contagem = {};
  const produtosPorId = {};

  for (const item of carrinho) {
    const id = item?.produto?._id;
    if (!id) continue;
    contagem[id] = (contagem[id] || 0) + 1;
    produtosPorId[id] = item.produto;
  }

  const mensagens = [];
  for (const id of Object.keys(contagem)) {
    const { valido, mensagem } = validarQuantidadeProduto(
      produtosPorId[id],
      contagem[id],
    );
    if (!valido) mensagens.push(mensagem);
  }

  return mensagens;
};
